export const dollarsToCents = function (dollars) {
    dollars = Number.parseFloat(dollars)
    return Number.isNaN(dollars) ? null : Math.round(dollars * 100)
}

export const centsToDollars = function (cents) {
    cents = Number.parseInt(cents)
    return Number.isNaN(cents) ? null : cents / 100
}

const wholeDollarsFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    roundingMode: "ceil",
})

const dollarsCentsFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
})

export const formatCurrency = function (value, fromUnit = "cents", includeCents = true) {
    if (value == null) {
        return null
    }

    if (typeof value === "string") {
        value = Number.parseFloat(value)
    }

    if (fromUnit === "cents") {
        value = value / 100
    }

    let formatter

    if (includeCents) {
        formatter = dollarsCentsFormatter
    } else {
        formatter = wholeDollarsFormatter
    }

    return formatter.format(value)
}

export const formatWholeCurrency = function (value, fromUnit = "cents") {
    return formatCurrency(value, fromUnit, false)
}

export default {
    centsToDollars,
    dollarsToCents,
    formatCurrency,
}
